/** ponytail: coerce API/Redux list fields to [] when token expires or payload shape drifts */
export const asArray = (val) => (Array.isArray(val) ? val : []);
